import { withSafeSuspense } from '@calendly/safe-suspense'
import { lazy } from 'react'

export const WorkflowsHome = withSafeSuspense(lazy(
  async () => ({ default: (await import('./home')).WorkflowsHome })
))
